import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface AgentCommissionFilterDto {
    agentId?: string;
    fromDate?: string;
    toDate?: string;
    isSettled?: boolean;
    pageIndex: number;
    pageSize: number;
}

export interface AgentCommissionDto {
    scrapCollectionId: string;
    collectionId: string;
    agentId: string;
    agentName: string;
    collectionDate: string;
    grandTotal: number;
    agentVoucherCommission: number;
    agentVoucherCommissionPercentage: number;
    isAgentVoucherCommissionSettled: boolean;
    agentVoucherCommissionNotes?: string;
}

export interface PaginatedResponse<T> {
    items: T[];
    totalCount: number;
    pageIndex: number;
    pageSize: number;
}

export interface BatchUpdateSettlementDto {
    scrapCollectionIds: string[];
    isSettled: boolean;
    notes?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AgentCommissionService {
  private apiUrl = `${environment.apiConfig.uri}/api/AgentCommission`;

  constructor(private http: HttpClient) { }

  getAgentCommissions(filter: AgentCommissionFilterDto): Observable<PaginatedResponse<AgentCommissionDto>> {
    let params = new HttpParams()
      .set('PageIndex', filter.pageIndex.toString())
      .set('PageSize', filter.pageSize.toString());

    if (filter.agentId) {
      params = params.set('AgentId', filter.agentId);
    }
    if (filter.fromDate) {
      params = params.set('FromDate', filter.fromDate);
    }
    if (filter.toDate) {
      params = params.set('ToDate', filter.toDate);
    }
    if (filter.isSettled !== undefined && filter.isSettled !== null) {
      params = params.set('IsSettled', filter.isSettled.toString());
    }

    return this.http.get<PaginatedResponse<AgentCommissionDto>>(`${this.apiUrl}/list`, { params });
  }

  updateAgentCommissionSettlementBatch(batchSettlementDto: BatchUpdateSettlementDto): Observable<any> {
    return this.http.post(`${this.apiUrl}/batch-settle`, batchSettlementDto);
  }
}
